// services/modelPermissionsService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'model-permissions/';

export interface ModelPermission {
    id: number;
    user_level: number;
    model_name: string;
    can_create: boolean;
    can_read: boolean;
    can_update: boolean;
    can_delete: boolean;
}

// GET: Obtener todos los permisos
export const fetchModelPermissions = async (): Promise<ModelPermission[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ModelPermission[]>(API_URL);
        return response.data;
    });
};



// services/modelPermissionsService.ts

// …otros imports
export interface ModelOption {
    model_name: string;
    verbose_name: string;
}

// GET: Obtener todos los modelos disponibles
export const fetchModels = async (): Promise<ModelOption[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ModelOption[]>('models-list/');
        return response.data;
    });
};




// GET: Obtener permisos filtrados por user_level o model_name
export const fetchModelPermissionsByFilter = async (params: {
    user_level?: number;
    model_name?: string;
}): Promise<ModelPermission[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<ModelPermission[]>(API_URL, { params });
        return response.data;
    });
};

// POST: Crear un nuevo permiso
export const createModelPermission = async (data: {
    user_level: number;
    model_name: string;
    can_create?: boolean;
    can_read?: boolean;
    can_update?: boolean;
    can_delete?: boolean;
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar un permiso existente
export const updateModelPermission = async (
    id: number,
    data: {
        user_level: number;
        model_name: string;
        can_create?: boolean;
        can_read?: boolean;
        can_update?: boolean;
        can_delete?: boolean;
    }
) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar un permiso
export const deleteModelPermission = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};
